import axiosNew from "../../../helpers/axios";
import { cleanObject } from "../../../helpers/queryBuilder";

export const getAllProjectSaveReport = async (data) => {
    const { skip, limit, projectId, userId, reportName } = data;
    // const skip = page && limit ? (page - 1) * limit : 0;
    let bodyData = cleanObject({
        skip,
        limit,
        projectId,
        userId,
        ...(reportName && {
            search: {
                reportName: reportName,
            },
        }),
    });


    try {
        const res = await axiosNew({
            url: 'save-report/list',
            data: bodyData,
        })
        return res.data ?? {};
    } catch (error) {
        console.error("getAllProjectSaveReport error:", error);
        throw error.response?.data || error.message;
    }
};



export const updateReport = async (id, payload) => {



    const body = cleanObject(payload)
    try {
        const res = await axiosNew({
            url: 'save-report/update/' + id,
            method: 'PUT',
            data: body,
        })
        return { data: res.data ?? {} };
    } catch (error) {
        return { data: error?.response?.data ?? {} };
    }
};
